module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-modal/theme/lui-modal.global.scss
// module id = 274
// module chunks = 0 1 31